export default __webpack_public_path__ + "static/media/bahar_bet.562fc924.svg";